/**
 * Normalizes AI output for single-line inputs (names, titles): plain text, no markdown.
 * Defense in depth — the API should also use the short_label prompt for generation.
 */
const MAX_INLINE_LEN = 200;

export function sanitizeInlineAiField(raw: string): string {
  let s = raw.trim();
  if (!s) return '';

  // Strip common markdown / formatting (order matters for nested patterns)
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1');
  s = s.replace(/\*([^*]+)\*/g, '$1');
  s = s.replace(/__([^_]+)__/g, '$1');
  s = s.replace(/_([^_]+)_/g, '$1');
  s = s.replace(/`([^`]+)`/g, '$1');
  s = s.replace(/^#{1,6}\s*/gm, '');
  s = s.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

  // One line for <input>
  s = s.replace(/\s+/g, ' ').trim();

  // Strip wrapping quotes if the model returned "Name" or «Name»
  if (
    (s.startsWith('"') && s.endsWith('"')) ||
    (s.startsWith('«') && s.endsWith('»')) ||
    (s.startsWith('„') && s.endsWith('“'))
  ) {
    s = s.slice(1, -1).trim();
  }

  if (s.length > MAX_INLINE_LEN) {
    s = s.slice(0, MAX_INLINE_LEN).trim();
    const lastSpace = s.lastIndexOf(' ');
    if (lastSpace > MAX_INLINE_LEN * 0.6) s = s.slice(0, lastSpace);
  }

  return s;
}
